import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT_APP } from 'store/sagas'

export const NAMESPACE = 'KanBo/toasts/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET = NAMESPACE + 'SET'

const initialState = {
  toasts: [],
  toastsById: {}
}

export const toastDefaults = {
  type: null,
  message: '',
  progress: false
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
      return {
        ...initialState
      }
    case ADD: {
      const newState = {
        ...state,
        toastsById: { ...state.toastsById }
      }
      newState.toasts = addUniqueValueToArray({
        array: newState.toasts,
        value: action.payload.id,
        index: 0
      })
      newState.toastsById[action.payload.id] = {
        ...toastDefaults,
        ...action.payload
      }
      return newState
    }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        toasts: [ ...state.toasts ],
        toastsById: { ...state.toastsById }
      }
      action.payload.forEach(toast => {
        newState.toasts = addUniqueValueToArray({
          array: newState.toasts,
          value: toast.id
        })
        newState.toastsById[toast.id] = {
          ...toastDefaults,
          ...toast
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        toasts: [ ...state.toasts.filter(id => id !== action.payload.id) ],
        toastsById: { ...state.toastsById }
      }
      delete newState.toastsById[action.payload.id]
      return newState
    }
    case SET:
      return state.toastsById[action.payload.id] ? {
        ...state,
        toastsById: {
          ...state.toastsById,
          [action.payload.id]: {
            ...state.toastsById[action.payload.id],
            ...action.payload.data
          }
        }
      } : state
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (toastsArray) {
  return {
    type: ADD_ARRAY,
    payload: toastsArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function set ({ id, ...data }) {
  return {
    type: SET,
    payload: {
      id,
      data
    }
  }
}
